"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _isValidClientAppConfigProperty = require("./isValidClientAppConfigProperty");
Object.keys(_isValidClientAppConfigProperty).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isValidClientAppConfigProperty[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isValidClientAppConfigProperty[key];
    }
  });
});
var _safeParseJson = require("./safeParseJson");
Object.keys(_safeParseJson).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _safeParseJson[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _safeParseJson[key];
    }
  });
});
//# sourceMappingURL=index.js.map